<template>
  <v-form ref="form" autocomplete="off" @submit.prevent="save">
    <v-row>
      <v-col cols="12">
        <v-text-field
            prepend-icon="point_of_sale"
            name="name"
            v-model="form.name"
            :label="$t('delivery.cashRegister.labels.name')"
            :placeholder="$t('delivery.cashRegister.labels.name')"
            :error="hasInputErrors('name')"
            :error-messages="getInputErrors('name')"
            color="secondary"
            :rules="required"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-select
            prepend-icon="person"
            name="users"
            v-model="form.users"
            :items="users"
            item-text="username"
            item-value="id"
            :label="$t('delivery.cashRegister.labels.user')"
            :placeholder="$t('delivery.cashRegister.labels.user')"
            :error="hasInputErrors('users')"
            :error-messages="getInputErrors('users')"
            color="secondary"
            item-color="secondary"
            multiple
            chips
            :loading="loadingUsers"
            :rules="usersRequired"
        ></v-select>
      </v-col>

      <v-col cols="12" sm="6" v-for="user in selectedUsers" :key="user.id">
        <v-text-field
            prepend-icon="email"
            :value="user.email"
            :label="$t('delivery.cashRegister.labels.email')"
            readonly
            color="secondary"
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="6" v-for="user in selectedUsers" :key="`${user.id}_role`">
        <v-text-field
            prepend-icon="security"
            :value="user.role ? user.role.name : ''"
            :label="$t('delivery.cashRegister.labels.role')"
            readonly
            color="secondary"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-btn text color="secondary" @click="focusUsers">
          <v-icon left>add</v-icon>
          {{ $t('delivery.cashRegister.actions.addUser') }}
        </v-btn>
      </v-col>

      <v-col cols="12">
        <v-switch
            prepend-icon="verified"
            name="active"
            v-model="form.active"
            :label="$t('delivery.cashRegister.labels.active')"
            :error="hasInputErrors('active')"
            :error-messages="getInputErrors('active')"
            color="success"
        ></v-switch>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'
import {userProvider} from '@dracul/user-frontend'

export default {
  name: "CashRegisterForm",
  mixins: [InputErrorsByProps, RequiredRule],
  props: {
    value: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      users: [],
      loadingUsers: false
    }
  },
  computed: {
    form: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    selectedUsers() {
      return this.users.filter(user => this.form.users.includes(user.id))
    },
    usersRequired() {
      return [v => (Array.isArray(v) && v.length > 0) || this.$t('common.required')]
    }
  },
  mounted() {
    this.fetchUsers()
  },
  watch: {
    form: {
      handler(newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  methods: {
    fetchUsers() {
      this.loadingUsers = true
      userProvider.paginateUsers(1000, 1, null, 'username', false, true)
          .then(r => {
            this.users = r.data.paginateUsers.users
          })
          .catch(err => console.error(err))
          .finally(() => this.loadingUsers = false)
    },
    focusUsers() {
      const input = this.$el.querySelector('[name="users"]')
      if (input) input.focus()
    },
    validate() {
      return this.$refs.form.validate()
    },
    save() {
      this.$emit('save', this.form)
    }
  }
}
</script>
